const version = '5.3.1';

export { version };
//# sourceMappingURL=govuk-frontend-version.mjs.map
